import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionValuesFieldPath = () => {
  const condition = useConditionFieldPath();
  return `${condition}.values` as const;
};
